var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "h3",
        {
          staticClass: "title",
          attrs: { content: "edit", placement: "bottom" }
        },
        [
          _vm._v("\n    IR Users Management\n    "),
          _c(
            "span",
            {
              staticClass: "search-toggle",
              on: {
                click: function($event) {
                  _vm.searchExpanded = !_vm.searchExpanded
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.searchExpanded ? "Hide Filters" : "Show Filters") +
                  "\n      "
              ),
              _c("em", {
                staticClass: "el-icon-arrow-up",
                class: { "is-collapsed": !_vm.searchExpanded }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.searchExpanded,
              expression: "searchExpanded"
            }
          ],
          staticClass: "searchBox"
        },
        [
          _c(
            "el-form",
            {
              ref: "formInline",
              staticClass: "demo-form-inline",
              attrs: { model: _vm.formInline }
            },
            [
              _c(
                "div",
                { staticClass: "search-grid" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "lastName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "Last Name", maxlength: "50" },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitSearch.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.formInline.lastName,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "lastName", $$v)
                          },
                          expression: "formInline.lastName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "firstName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "First Name", maxlength: "50" },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitSearch.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.formInline.firstName,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "firstName", $$v)
                          },
                          expression: "formInline.firstName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "search-toolbar" }, [
            _c(
              "div",
              { staticClass: "search-toolbar__actions" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "search",
                    attrs: { type: "primary" },
                    on: { click: _vm.submitSearch }
                  },
                  [_vm._v("Search")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "reset",
                    on: {
                      click: function($event) {
                        return _vm.resetForm("formInline")
                      }
                    }
                  },
                  [_vm._v("Reset")]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "client-panel" },
        [
          _c(
            "div",
            { staticClass: "client-panel__toolbar" },
            [
              _c("columns-control", {
                attrs: {
                  columns: _vm.columnsConfig,
                  "storage-key": "cms.irManagement.columns"
                },
                on: { change: _vm.onColumnsChange }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            { attrs: { data: _vm.tableData } },
            [
              _vm.isColumnVisible("employeeId")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "employeeId",
                      label: "Employee ID",
                      width: "100"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [_vm._v(_vm._s(scope.row.employeeId))]
                          }
                        }
                      ],
                      null,
                      false,
                      1704163954
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("fullName")
                ? _c("el-table-column", {
                    attrs: { label: "Full Name" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [_vm._v(_vm._s(scope.row.fullName))]
                          }
                        }
                      ],
                      null,
                      false,
                      1973410729
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("email")
                ? _c("el-table-column", {
                    attrs: { label: "Email" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.email) +
                                  "\n        "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2954695793
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("phone")
                ? _c("el-table-column", {
                    attrs: { label: "Phone" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.phone) +
                                  "\n        "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1070346721
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("username")
                ? _c("el-table-column", {
                    attrs: { label: "Username" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.username) +
                                  "\n        "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2723718795
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("employeeStatus")
                ? _c("el-table-column", {
                    attrs: { label: "Employee Status" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.employeeStatus) +
                                  "\n        "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      921176459
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("status")
                ? _c("el-table-column", {
                    attrs: { label: "Status" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.formatStatus(scope.row.status)) +
                                  "\n        "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3702504191
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Operations", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "More",
                              placement: "top"
                            }
                          },
                          [
                            _c(
                              "el-dropdown",
                              {
                                attrs: { trigger: "click" },
                                on: {
                                  command: function(command) {
                                    return _vm.handleMore(command, scope.row)
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "el-dropdown-link sortbox" },
                                  [_c("em", { staticClass: "more" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown"
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "invite" } },
                                      [_vm._v("Invite")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "resetPassword" } },
                                      [_vm._v("Reset password")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "deactivate" } },
                                      [_vm._v("Deactivate")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("app-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [5, 10, 20, 50],
              total: _vm.total,
              "page-size": _vm.currentSize
            },
            on: {
              "size-change": function(v) {
                _vm.currentSize = v
                _vm.currentPage = 1
                _vm.getList()
              },
              "current-change": function(v) {
                _vm.currentPage = v
                _vm.getList()
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "IR Account Detail",
            visible: _vm.inviteDialogVisible,
            width: "400px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              _vm.inviteDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.inviteForm,
                "label-position": "left",
                "label-width": "120px"
              }
            },
            [
              _c("el-form-item", { attrs: { label: "Full Name" } }, [
                _c("span", [_vm._v(_vm._s(_vm.inviteForm.fullName))])
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Email address" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Please enter email address" },
                    model: {
                      value: _vm.inviteForm.email,
                      callback: function($$v) {
                        _vm.$set(_vm.inviteForm, "email", $$v)
                      },
                      expression: "inviteForm.email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Phone number" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Please enter phone number" },
                    on: { input: _vm.onInvitePhoneInput },
                    model: {
                      value: _vm.inviteForm.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.inviteForm, "phone", $$v)
                      },
                      expression: "inviteForm.phone"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.inviteDialogVisible = false
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.inviteSubmitting },
                  on: { click: _vm.submitInvite }
                },
                [_vm._v("Send")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e880b62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e880b62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/portalIRUser/portalIRUser.vue
// module id = null
// module chunks = 